
import {DeleteForeverOutlined} from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Button, IconButton, InputAdornment, Stack } from '@mui/material';
import {Tooltip } from '@mui/material';
import dayjs from 'dayjs';
//import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

// import Swal from 'sweetalert2';
import FileList from '../../Components/cra/FileList';
import DialogRejetCraAndCraX from '../../Components/Dialogs/DialogRejetCraAndCraX';
import { buttonStyles, buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import { DatePickerComponent, IconTextField, SelectComponent, TextFieldComponent } from '../../Components/shared/ReusableSmallComponents';
import { getStatusCraLabel, STATUS_CRA } from '../../data/Interfaces';
import { EncourIcon, RejetIcon, ValiderIcon } from '../../data/SVGs';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useIsExpertEsn from '../../hooks/useIsExpertEsn';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import usePostRequest from '../../hooks/usePostRequest';
import useRole from '../../hooks/useRole';
import MultipleFilesUpload from '../../Utils/fileUpload/MultipleFileUpload';
import { minutesDifferenceToDecimalHours } from '../../Utils/getCalendarMonthMatrix';
import { isHttpStatusSuccess } from '../../Utils/utils';
// import { isHttpStatusSuccess } from '../../Utils/utils';
import { calculateIsMontantOrCoeffOfAstreinte, calculateMontantTotal, calculateMontantTotalAstreintes, calculateMontantTotalHnos, calculateMontantTotalNoteFrais, calculateMontantTotalOfOneAstreinte, calculateMontantTotalOfOneHno, filesAddapter, getDisabledValidateRejectCraForACanceledMission, initializeAstreinte, initializeHNO, initializeNotesFrais } from '../../Utils/utilsCraX';

export function StatutCra({statutCra,motifRejet}) {
    StatutCra.propTypes = {
        statutCra: PropTypes.any,
        motifRejet:PropTypes.any,
    };
    const { i18n } = useTranslation();
    usePersistedLanguage();
    return (
        <>
            {/*{hover && statutCra == STATUS_CRA.NV && (<div style={{zIndex:'7'}}><Alert severity="error">{motifRejet}</Alert></div>)}*/}
            {(statutCra == STATUS_CRA.NV || statutCra == STATUS_CRA.NULL) && (
                <div style={{display:'flex',flexDirection:'row',alignItems: 'center'}}>
                    <div
                        className="frame20Kbis"
                    >
                        <div className="frame21Kbis">
                            <RejetIcon />
                        </div>
                        <p className="frame22Kbis">{i18n.t(getStatusCraLabel(statutCra))}</p>
                    </div>
                    <Tooltip title={motifRejet}>
                        <InfoOutlinedIcon/>
                    </Tooltip>
                </div>
            )}

            {(statutCra==STATUS_CRA.VC) &&
                <div className='frame23Kbis'>
                    <div className='frame21Kbis'>
                        <ValiderIcon/>
                    </div>
                    <p className='frame24Kbis'>
                        {i18n.t(getStatusCraLabel(statutCra))}
                    </p>
                </div>
            }

            {(statutCra==STATUS_CRA.pending || statutCra==STATUS_CRA.VE) &&
            <div className='frame25Kbis'>
                <div className='frame21Kbis'>
                    <EncourIcon />
                </div>
                <p className='frame26Kbis'>
                    {i18n.t(getStatusCraLabel(statutCra))}
                </p>
            </div>
            }
        </>
    );
}
const CraX = () => {
    const navigate = useNavigate();
    const { postDataSilently, postData} = usePostRequest();
    const axiosPrivate = useAxiosPrivate();
    const {craXId} = useParams();
    const { state: cra } = useLocation();
    const [craX, setCraX] = useState();
    const [astreintes, setAstreintes] = useState([]);
    const [hnos, setHnos] = useState([]);
    const [notesFrais, setNotesFrais] = useState([]);
    const [note, setNote] = useState('');
    const [fileList, setFileList] = useState([]);
    const isEsnExpert=useIsExpertEsn();
    const [refCra,setRefCras]=useState('');
    const [month,setMonth]=useState();
    const [yearCra,setYearCra]=useState();
    const [isMontant,setIsMontant]=useState(true);
    const [nbrHrHno,setNbrHrHno]=useState(8);
    const { i18n } = useTranslation();
    const tj= cra?.tj??craX?.tj;
    const tjClient= cra?.tjClient??craX?.tjClient;
    // * OLD commissionHTH
    const [openDialogRejetCras, setOpenDialogRejetCras] = useState(false);
    const [isValidTime, setIsValidTime] = useState([]);
    // * prestationsComplementairesCLientData specified for the client
    const [prestationsComplementairesCLientData, setPrestationsComplementairesCLientData] = useState([]);
    const role = useRole();
    const totalAstreintes = useMemo(() => calculateMontantTotalAstreintes(astreintes,isMontant,defineRole(role),tj,tjClient), [astreintes,isMontant]);
    //const totalHnos = useMemo(() => calculateMontantTotalHnos({hnosFileList:hnos, tj:tj, role: role, tjClient: tjClient}), [hnos]);

    const totalHnos = useMemo(() => {
        const calculatedTotalHnos = calculateMontantTotalHnos({hnosFileList: hnos, tj: tj, role: defineRole(role), tjClient: tjClient, nbrHrHno:nbrHrHno});
        console.log('calculatedTotalHnos',calculatedTotalHnos);
        return calculatedTotalHnos.toFixed(2);
    }, [hnos]);

    const totalNotesFrais = useMemo(() => calculateMontantTotalNoteFrais(notesFrais), [notesFrais]);
    const [disabledBtnValidation,setDisabledBtnValidation]=useState(true);

    // const montantTotal = useMemo(() => calculateMontantTotal({
    //         astreintesFileList: astreintes,
    //         hnosFileList: hnos,
    //         notesFraisFileList: notesFrais,
    //         tj: tj,
    //         role: role,
    //         tjClient: tjClient,
    //         isMontant:isMontant,
    //         nbrHrHno:nbrHrHno,
    //     }), [astreintes, hnos, notesFrais]);

    const [montantTotal,setMontantTotal]=useState(0);
    console.log('cra',cra);
    useEffect(() => {
        const montantTotal = calculateMontantTotal({
            astreintesFileList: astreintes,
            hnosFileList: hnos,
            notesFraisFileList: notesFrais,
            tj: tj,
            role: defineRole(role),
            tjClient: tjClient,
            isMontant:isMontant,
            nbrHrHno:nbrHrHno,
        });
        setMontantTotal(montantTotal);
    }, [notesFrais,astreintes,hnos,fileList]);

    useEffect(() => {
        console.log({montantTotal});
        if(
            (notesFrais.length>0 || astreintes.length>0 || hnos.length>0 || fileList.length>0) &&
            montantTotal !== 0
        ){
            setDisabledBtnValidation(false);
        }
        else
            setDisabledBtnValidation(true);
    }, [notesFrais,astreintes,hnos,fileList, montantTotal]);

    useEffect(() => {
        console.log('cra version final',cra);
    }, [cra]);
    useEffect(() => {
        const role = cra?.missionId?.esnId ? 'esn':'client';
        const companyDataId = cra?.missionId?.companyDataId?._id;
        const esnId = cra?.missionId?.esnId?._id;
        if (companyDataId ?? esnId) {
            getClientPrestationComplementaireData(esnId ?? companyDataId,role);
        }
        setMonth(cra?.month);
        setYearCra(cra?.year);

        // * will be usefull if we refresh inside craX creation process
        if(cra?.craType !== 'CRAX' && cra?._id){
            getCraXByCraId(cra?._id);
        }
    }, [cra]);
    useEffect(() => {
        console.log(craXId);
        // * will be usefull in case of client/admin roles + share link
        if(craXId){
            getCraXById(craXId);
        }
    }, [craXId]);
    // useEffect(() => {
    //     if(astreintes.length > 0 || hnos.length > 0 || notesFrais.length >0 ){
    //         setMontantTotal(calculateMontantTotal({
    //             astreintesFileList: astreintes,
    //             hnosFileList: hnos, notesFraisFileList: notesFrais,
    //             tj: tj,
    //         }));
    //     }
    // }, [astreintes,hnos, notesFrais]);
    const updateCraX = (craX) => {
        console.log('craaaaaaaaaaaax',craX);
        if(craX?._id){
            setCraX(craX);
            setAstreintes(craX?.astreintes);
            setHnos(craX?.hnos);
            setRefCras(craX?.craXId);
            setYearCra(craX?.year);
            if(craX?.month) setMonth(craX?.month);
            setNotesFrais(craX?.notesFrais);
            if(craX?.note!='undefined')
                setNote(craX?.note);
            setFileList(filesAddapter(craX?.files));

        }
    };
    const getClientPrestationComplementaireData = async (companyDataId,role) => {
        const response1 = await postDataSilently({
            url: `/${role}/getClientPrestationComplementaireData`,
            payload:{
                ...(role === 'esn' ? { esnId: companyDataId } : { companyDataId })
            }
        });
        var astreintes=[];
        var hnos=[];
        if(response1?.data?.prestationsComplementaires?.rules?.isMontant!=undefined)
            setIsMontant(response1?.data?.prestationsComplementaires?.rules?.isMontant);
        if(response1?.data?.prestationsComplementaires?.rules?.nbrHrsHNOs)
            setNbrHrHno(response1?.data?.prestationsComplementaires?.rules?.nbrHrsHNOs);

        response1.data?.prestationsComplementaires?.astreintes?.map((element) => {
            astreintes.push({_id:element?._id,montant:element?.montant ,label:element?.type,value:element?.type});
        });
        response1.data?.prestationsComplementaires?.hnos?.map((element) => {
            hnos.push({_id:element?._id,montant:element?.montant ,label:element?.type,value:element?.type});
        });

        setPrestationsComplementairesCLientData({astreintes:astreintes,hnos:hnos, rules: response1.data?.prestationsComplementaires?.rules});
    };

    const getCraXById = async (craXId) => {
        try {
            const response = await axiosPrivate.get(`/cra/getCraXById/${craXId}`);
            console.log('craX',response.data);
            updateCraX(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const getCraXByCraId = async (craId) => {
        const response1 = await postDataSilently({
            url: '/cra/getCraXByCraId',
            payload: {
                craId
            }
        });
        console.log(response1);
        console.log('craaa',response1.data);
        updateCraX(response1.data);
    };

    const updateStatutCraXByClient = async ({craXId, statutCraX}) => {
        const response1 = await postData({
            url: '/cra/updateStatutCraXByClient',
            payload: {
                craXId,
                statutCraX
            }
        });
        // console.log(response1);
        //* J’ai reçu un message du backend après validation du CRA PC+le swall  il faut l’enlever
        // if (isHttpStatusSuccess(response1?.responseStatus)) {
        //     navigate(-1);
        //     Swal.fire({
        //         title: 'Le CRA de l\'expert a été validé avec succès!',
        //         icon:'success',
        //         confirmButtonColor: '#5CC889',
        //         confirmButtonText: 'Ok',
        //     });
        // }
        getCraXById(response1.data?.updatedCraX?._id);
    };

    const handleKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };

    function defineRole(role) {
        if(
            role === 'client' ||
          (role === 'esn' && !location.pathname.includes('CraXVente'))
        ) {
            return 'client';
        }
        else if (role === 'expert' || (role === 'esn' && location.pathname.includes('CraXVente')))
            return 'expert';
        return role;
    }

    const addCraX = async () => {
        const formData = new FormData();
        // * if we came from the cra page
        if(cra?.craType !== 'CRAX'){
            formData.append('craId', cra?._id);
        }
        // * if we came from the all cra table
        else{
            formData.append('craId', cra?.craId);
        }
        formData.append('missionId', cra?.missionId?._id);
        formData.append('bdcId', (cra?.bdcId?._id || cra?.bdcId));
        // *calculs
        formData.append('totalAstreintes',totalAstreintes);
        formData.append('totalAstreintesClient', calculateMontantTotalAstreintes(astreintes,isMontant,'client',tj,tjClient));
        formData.append('totalHnos',totalHnos),

        formData.append('totalHnosClient',calculateMontantTotalHnos({
            hnosFileList:hnos,
            role: 'client',
            tjClient: tjClient,
            nbrHrHno:nbrHrHno
            //  tj:tj,
        })),

        formData.append('totalNotesFrais',totalNotesFrais),
        formData.append('montantTotal', montantTotal);
        formData.append('montantTotalClient', calculateMontantTotal({
            astreintesFileList: astreintes,
            hnosFileList: hnos,
            notesFraisFileList: notesFrais,
            tjClient: tjClient,
            role: 'client',
            isMontant:isMontant,
            nbrHrHno:nbrHrHno,
        }));
        formData.append('astreintes', JSON.stringify(astreintes));
        formData.append('hnos', JSON.stringify(hnos));
        formData.append('notesFrais', JSON.stringify(notesFrais));
        formData.append('note', note);
        formData.append('rules', JSON.stringify(prestationsComplementairesCLientData?.rules));
        let existedFilesTemp =[];
        for (let i = 0; i < fileList.length; i++) {
            if(fileList[i]?.isFromBackend) {
                existedFilesTemp.push(fileList[i]);
            }
            else {formData.append(`craXFile${i}`, fileList[i]);}
        }
        formData.append('existedFilesOnBackend', JSON.stringify(existedFilesTemp));
        const response1 = await postDataSilently({
            url: '/cra/addCraX',
            payload: formData,
        });
        console.log(response1);
        if (isHttpStatusSuccess(response1?.responseStatus)) {
            navigate(`/${role}/AllCras`);
            Swal.fire({
                title: i18n.t(response1?.data?.message),
                icon:'success',
                confirmButtonColor: '#5CC889',
                confirmButtonText: 'Ok',
            });
        }
        updateCraX(response1?.data?.createdCraX??response1?.data?.updatedCraX);
    };
    return (
        <form
            style={{alignSelf:'stretch',gap:'24px',display:'flex',flexDirection:'column'}}
        >
            <div className="FrameBox3Reg">
                <h4 className='titlesociete'>{i18n.t('Prestation complémentaire')} &nbsp; {refCra}
                </h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px',paddingTop:'12px' }}>
                    <StatutCra
                        statutCra={craX?.statutCraX}
                        motifRejet={craX?.motifR}
                    />
                    <div style={{ display: 'flex', flexDirection: 'row',alignSelf:'center', gap: '4px',order:2 }}>
                        <CalendarTodayIcon />
                        <p className='datestyilng'>
                            {month !== '' ? dayjs(new Date(yearCra, month-1)).format('MMMM') : ''} {yearCra}
                        </p>
                    </div>
                </div>
            </div>

            <div className='FrameBox0Reg'>
                <h6 className='nomPrenomProfile'>
                    {i18n.t('Astreintes')}
                </h6>
                {role && Array.isArray(astreintes) && astreintes.map((astreinte, i) => (
                    <div
                        className="FrameBox1Reg"
                        key={i}
                    >
                        <div
                            className="FrameBox4Reg"
                            style={{width:'30%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Type d\'astreinte')} </label>
                            {defineRole(role) == 'expert'?
                                <SelectComponent
                                    val={astreinte?.type}
                                    setVal={(e) => {
                                        let newArr = [...astreintes];
                                        newArr[i].type = e.target.value;
                                        newArr[i].montantUnit = prestationsComplementairesCLientData?.astreintes?.find(item => item.label === e.target.value)?.montant;
                                        setAstreintes(newArr);
                                        console.log(e.target.value);
                                    }}
                                    disabled={defineRole(role) == 'client'|| role =='admin'||(defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC)}
                                    listVal={prestationsComplementairesCLientData?.astreintes}
                                />
                                :
                                <TextFieldComponent
                                    value={astreinte?.type}
                                    disabled={defineRole(role) == 'client'|| role =='admin' || (defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC)}
                                />
                            }
                        </div>
                        <div className="FrameBox4Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Date')} </label>
                            <DatePickerComponent
                                date={astreinte?.date}
                                setDate={(newValue) => {
                                    let newArr = [...astreintes];
                                    newArr[i].date = newValue;
                                    setAstreintes(newArr);
                                }}
                                disabled={defineRole(role) == 'client'|| role =='admin'|| (defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC)}
                                width={'100%'}
                            />
                        </div>
                        {!isEsnExpert &&
                        <div className="FrameBox4Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Montant/unité')} </label>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { width: '100%', borderRadius: '8px' },
                                }}
                                type="number"
                                iconEnd='€'
                                name="montantUnit"
                                // placeholder="Intitulé du poste"
                                value={calculateIsMontantOrCoeffOfAstreinte(astreinte?.montantUnit,isMontant,defineRole(role),tj,tjClient)}
                                disabled
                            />
                        </div>
                        }

                        <div className="FrameBox4Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Nb d\'astreintes')} </label>
                            <TextFieldComponent
                                id="#"
                                //sx={{ width: '95px' }}
                                type='number'
                                onChange={(e) => {
                                    let newArr = [...astreintes];
                                    newArr[i].nbrAstreintes = e.target.value;
                                    setAstreintes(newArr);
                                    console.log(e.target.value);
                                }}
                                onKeyDown={handleKeyDown}
                                InputProps={{
                                    inputProps: { min: 1,}
                                }}
                                value={astreinte?.nbrAstreintes}
                                // variant="standard"
                                style={{ borderRadius: '8px', background: 'white' }}
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px', width: '100%' }
                                }}
                                // focused
                                disabled={defineRole(role) == 'client'|| role =='admin'|| (defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC)}
                            />
                        </div>
                        {!isEsnExpert &&
                        <div className="FrameBox4Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Total')}</label>
                            <IconTextField

                                sx={{
                                    '& > :not(style)': {width: '100%', borderRadius: '8px' },
                                }}
                                type="number"
                                iconEnd={'€'}
                                // name="intitulePoste"
                                // placeholder="Intitulé du poste"
                                autoComplete="off"
                                value={calculateMontantTotalOfOneAstreinte(astreinte,isMontant,defineRole(role),tj,tjClient,)}
                                disabled
                            />
                        </div>}
                        {(defineRole(role)=='expert'&& craX?.statutCraX != STATUS_CRA.VC) &&
                            <div className='FrameBox5Reg'>
                                {/* <IconButton
                                    onClick={(e) => {
                                        let index = astreintes.length;
                                        let newArr = [...astreintes]; // copying the old datas array
                                        newArr.push(initializeAstreinte(index));
                                        setAstreintes(newArr);
                                        console.log(e, astreintes);
                                    }}
                                >
                                    <AddIcon />
                                </IconButton> */}
                                <IconButton
                                    onClick={(e) => {
                                        // e.preventDefault()
                                        // delete the index element by distructuring the array in two part without taking the i element
                                        let newArr = [
                                            ...astreintes.slice(0, i),
                                            ...astreintes.slice(i + 1, astreintes.length),
                                        ];
                                        // let newArr = [...experienceState]; // copying the old datas array
                                        // replace e.target.value with whatever you want to change it to
                                        setAstreintes(newArr);
                                        console.log(e, astreintes);
                                    }}
                                >
                                    <DeleteForeverOutlined />
                                </IconButton>
                            </div>
                        }
                    </div>
                ))}
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignSelf:'stretch'}}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {(defineRole(role)=='expert'&& craX?.statutCraX != STATUS_CRA.VC) &&
                        <Button
                            onClick={(e) => {
                                let index = astreintes.length;
                                let newArr = [...astreintes]; // copying the old datas array
                                newArr.push(initializeAstreinte(index));
                                setAstreintes(newArr);
                                console.log(e, astreintes);
                            }}
                            style={{
                                fontFamily: 'Lato',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '16px',
                                height:'50px',
                                letterSpacing: '-0.0044em',
                            }}
                            startIcon={<AddIcon />}
                        >{i18n.t('Ajouter une Astreinte')}</Button>}
                    </div>
                    {!isEsnExpert &&
                    <div
                        style={{
                            display: 'flex',
                            width: '20%',
                            gap: '16px',
                            marginRight:defineRole(role)=='expert' ? '56px' : '0px',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                        }}
                    >
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Total des astreintes')}</label>
                        <IconTextField
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            iconEnd={'€'}
                            style={{ width: '100%', background: 'white',}}
                            value={totalAstreintes}
                            disabled
                            name="tauxJournalierExpert"
                        />
                    </div>}
                </div>
            </div>

            <div className='FrameBox0Reg'>
                <h6 className='nomPrenomProfile'>
                    {i18n.t('HNO')}
                </h6>
                {Array.isArray(hnos) && hnos.map((hno, i) => (
                    <div
                        className="FrameBox1Reg"
                        key={i}
                    >

                        <div
                            className="FrameBox14Reg"
                            style={{width:'30%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Type d\'HNO')} </label>
                            {defineRole(role) == 'expert' ?
                                <SelectComponent
                                    val={hno?.type}
                                    setVal={(e) => {
                                        let newArr = [...hnos];
                                        newArr[i].type = e.target.value;
                                        newArr[i].coefficient = prestationsComplementairesCLientData?.hnos?.find(item => item?.label === e.target.value)?.montant;
                                        console.log(newArr, e.target.value, prestationsComplementairesCLientData?.hnos?.find(item => item?.type === e.target.value));
                                        setHnos(newArr);
                                    }}
                                    disabled={defineRole(role) == 'client'|| role =='admin' ||(defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC)}
                                    listVal={prestationsComplementairesCLientData?.hnos}
                                />
                                :
                                <TextFieldComponent
                                    value={hno?.type}
                                    disabled={defineRole(role) == 'client'|| role =='admin' || (defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC)}
                                />
                            }
                        </div>
                        <div className="FrameBox14Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Date')} </label>
                            <DatePickerComponent
                                date={hno?.date}
                                setDate={(newValue) => {
                                    let newArr = [...hnos];
                                    newArr[i].date = newValue;
                                    setHnos(newArr);
                                }}
                                disabled={defineRole(role) == 'client'|| role =='admin' ||(defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC)|| !hno?.type}
                                width={'100%'}
                            />
                        </div>
                        <div className="FrameBox14Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Heure début')} </label>
                            <TextFieldComponent
                                name="montantUnit"
                                id="time"
                                type="time"

                                sx={{
                                    '& > :not(style)': { width: '100%', borderRadius: '8px' },
                                }}
                                // placeholder="Intitulé du poste"
                                value={hno?.heureDebut}
                                onChange={(e) => {
                                    let newArr = [...hnos];
                                    newArr[i].heureDebut = e.target.value;
                                    setHnos(newArr);
                                }}
                                disabled={defineRole(role) == 'client'|| role =='admin' ||(defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC) || !hno?.type}
                            />
                        </div>
                        <div className="FrameBox14Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Heure fin')}  {isValidTime[i]==true && (<Tooltip title={i18n.t('Heure de fin doit être supérieure à heure de début')}><InfoOutlinedIcon style={{color:'red'}} /></Tooltip>)}</label>
                            <TextFieldComponent
                                name="montantUnit"
                                id="time"
                                type="time"

                                sx={{
                                    '& > :not(style)': { width: '100%', borderRadius: '8px' },
                                }}
                                value={hno?.heureFin}
                                onChange={(e) => {
                                    let newArr = [...hnos];
                                    newArr[i].heureFin = e.target.value;
                                    // Create a copy of the isValidTime object
                                    let newIsValidTime = [...isValidTime];

                                    // Update the condition for the specific index
                                    const isValTime = newArr[i].heureDebut > e.target.value;
                                    newIsValidTime[i] = isValTime;
                                    console.log('Heure fin fin fin fin',newIsValidTime);
                                    //Update the state
                                    setIsValidTime(newIsValidTime);
                                    if(isValTime==false){
                                        setHnos(newArr);
                                    }
                                }}
                                error={(isValidTime[i]==false || isValidTime[i]==undefined || isValidTime[i]=='') ? false : true}
                                //helperText={isValidTime==true?'':'Heure de fin doit être supérieure à heure de début'}
                                disabled={defineRole(role) == 'client'||role =='admin' || (defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC) || !hno?.type}
                            />
                        </div>
                        <div className="FrameBox14Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Nb d\'heures')} </label>
                            <TextFieldComponent
                                sx={{
                                    '& > :not(style)': { width: '100%', borderRadius: '8px' },
                                }}
                                // type="number"
                                // name="intitulePoste"
                                // placeholder="Intitulé du poste"
                                autoComplete="off"
                                value={`${minutesDifferenceToDecimalHours(hno?.heureDebut, hno?.heureFin)?.toFixed(2)}h`}
                                disabled
                            />
                        </div>
                        {!isEsnExpert &&
                        <div className="FrameBox14Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Montant')} </label>
                            <TextFieldComponent
                                sx={{
                                    '& > :not(style)': { width: '100%', borderRadius: '8px' },
                                }}
                                // ! if type number => vergule : 1,3, if pas de type (default is text) point : 1.3
                                type="number"
                                InputProps={{ endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>)}}
                                // name="intitulePoste"
                                // placeholder="Intitulé du poste"
                                // autoComplete="off"
                                value={calculateMontantTotalOfOneHno({
                                    hno:hno,
                                    tj:tj,
                                    tjClient:tjClient,
                                    role: defineRole(role),
                                    nbrHrHno:nbrHrHno
                                }).toFixed(2)}
                                disabled
                            />
                        </div>}
                        {(defineRole(role)=='expert'&& craX?.statutCraX != STATUS_CRA.VC) &&
                            <div className='FrameBox5Reg'>
                                {/* <IconButton
                                    onClick={(e) => {
                                        let index = hnos.length;
                                        let newArr = [...hnos]; // copying the old datas array
                                        newArr.push(initializeHNO(index));
                                        setHnos(newArr);
                                        console.log(e, hnos);
                                    }}
                                >
                                    <AddIcon />
                                </IconButton> */}
                                <IconButton
                                    onClick={(e) => {
                                        // e.preventDefault()
                                        // delete the index element by distructuring the array in two part without taking the i element
                                        let newArr = [
                                            ...hnos.slice(0, i),
                                            ...hnos.slice(i + 1, hnos.length),
                                        ];
                                        let newIsValidTime = [
                                            ...isValidTime.slice(0, i),
                                            ...isValidTime.slice(i + 1, isValidTime.length),];
                                        setIsValidTime(newIsValidTime);
                                        // let newArr = [...experienceState]; // copying the old datas array
                                        // replace e.target.value with whatever you want to change it to
                                        setHnos(newArr);
                                        console.log(e, hnos);
                                    }}
                                >
                                    <DeleteForeverOutlined />
                                </IconButton>
                            </div>
                        }

                    </div>
                ))}
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignSelf:'stretch'}}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {(defineRole(role)=='expert'&& craX?.statutCraX != STATUS_CRA.VC) &&
                        <Button
                            onClick={(e) => {
                                let index = hnos.length;
                                let newArr = [...hnos]; // copying the old datas array
                                newArr.push(initializeHNO(index));
                                setHnos(newArr);
                                console.log(e, hnos);
                            }}
                            style={{
                                fontFamily: 'Lato',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '16px',
                                letterSpacing: '-0.0044em',
                            }}
                            startIcon={<AddIcon />}
                        >{i18n.t('Ajouter une HNO')}</Button>}
                    </div>
                    {!isEsnExpert &&
                    <div style={{width:'20%',marginRight:defineRole(role)=='expert' ? '56px' : '0px',}}>
                        <div
                            className="FrameBox8Reg FrameBox18Reg"
                            style={{width:'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Total des HNO')}</label>
                            <TextFieldComponent
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px' },
                                }}
                                name="tatal HNO"
                                InputProps={{ endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>) }}
                                // placeholder="Intitulé du poste"
                                // autoComplete="off"
                                value={totalHnos}
                                disabled
                            />
                        </div>
                    </div>}
                </div>
                {/* <div className="FrameBox7Reg">
                    <div className="FrameBox14Reg">
                        <label className='AjouterDiplomeFrame7'>Total des HNO </label>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': { width: '100%', borderRadius: '8px' },
                            }}
                            type="number"
                            name="tatal HNO"
                            //label='Montant Total des HNO'
                            // placeholder="Intitulé du poste"
                            // autoComplete="off"
                            value={totalHnos}
                            disabled
                        />
                    </div>
                </div> */}
            </div>

            <div className="FrameBox0Reg">
                <h6 className='nomPrenomProfile'>
                    {i18n.t('Notes de frais')}
                </h6>
                {Array.isArray(notesFrais) && notesFrais.map((noteFrai, i) => (
                    <div
                        className="FrameBox1Reg"
                        key={i}
                    >
                        <div
                            className="FrameBox4Reg FrameBox15Reg"
                            style={{width:'50%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Type du note de frais')} </label>
                            <TextFieldComponent
                                sx={{
                                    '& > :not(style)': { width: '100%', borderRadius: '8px' },
                                }}
                                type="text"
                                // name="intitulePoste"
                                // placeholder="Intitulé du poste"
                                autoComplete="off"
                                value={noteFrai?.type}
                                onChange={(e) => {
                                    let newArr = [...notesFrais];
                                    newArr[i].type = e.target.value;
                                    setNotesFrais(newArr);
                                }}
                                disabled={defineRole(role) == 'client'|| role =='admin'|| (defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC)}
                            />
                        </div>

                        <div
                            className="FrameBox4Reg FrameBox15Reg"
                            style={{width:'50%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Montant')}</label>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { width: '100%', borderRadius: '8px' },
                                }}
                                type="number"
                                //InputProps={{ endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>)}}
                                iconEnd={'€'}
                                // name="intitulePoste"
                                // placeholder="Intitulé du poste"
                                // autoComplete="off"
                                value={noteFrai?.montant}
                                onChange={(e) => {
                                    let newArr = [...notesFrais];
                                    newArr[i].montant = e.target.value;
                                    setNotesFrais(newArr);
                                }}
                                disabled={defineRole(role) == 'client'|| role =='admin'||(defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC)}
                            />
                        </div>
                        {(defineRole(role)=='expert' && craX?.statutCraX!=STATUS_CRA.VC) &&
                            <div className='FrameBox5Reg'>
                                {/* <IconButton
                                    onClick={(e) => {
                                        let index = notesFrais.length;
                                        let newArr = [...notesFrais]; // copying the old datas array
                                        newArr.push(initializeNotesFrais(index));
                                        setNotesFrais(newArr);
                                        console.log(e, notesFrais);
                                    }}
                                >
                                    <AddIcon />
                                </IconButton> */}
                                <IconButton
                                    onClick={(e) => {
                                        // e.preventDefault()
                                        // delete the index element by distructuring the array in two part without taking the i element
                                        let newArr = [
                                            ...notesFrais.slice(0, i),
                                            ...notesFrais.slice(i + 1, notesFrais.length),
                                        ];
                                            // replace e.target.value with whatever you want to change it to
                                        setNotesFrais(newArr);
                                        console.log(e, notesFrais);
                                    }}
                                >
                                    <DeleteForeverOutlined />
                                </IconButton>
                            </div>
                        }
                    </div>
                ))}
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignSelf:'stretch'}}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {(defineRole(role)=='expert'&& craX?.statutCraX != STATUS_CRA.VC) &&
                        <Button
                            onClick={(e) => {
                                let index = notesFrais.length;
                                let newArr = [...notesFrais]; // copying the old datas array
                                newArr.push(initializeNotesFrais(index));
                                setNotesFrais(newArr);
                                console.log(e, notesFrais);
                            }}
                            style={{
                                fontFamily: 'Lato',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '16px',
                                letterSpacing: '-0.0044em',
                            }}
                            startIcon={<AddIcon />}
                        >{i18n.t('Ajouter une note de frais')}</Button>}
                    </div>
                    {!isEsnExpert &&
                    <div
                        className="FrameBox7Reg "
                        style={{width:'20%',marginRight:defineRole(role)=='expert' ? '56px' : '0px',}}
                    >
                        <div
                            className="FrameBox8Reg"
                            style={{width:'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Total des notes de frais')} </label>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px' },
                                }}
                                iconEnd={'€'}
                                //InputProps={{ endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>)}}

                                value={totalNotesFrais}
                                name="totalNotesFrais"
                            />
                        </div>
                    </div>}
                </div>
            </div>
            {!isEsnExpert &&
            <div className="FrameBox0Reg">
                <h6 className='nomPrenomProfile'>
                    {i18n.t('Montant total de la prestation complémentaire')}
                </h6>
                <div className="FrameBox1Reg FrameBox11Reg">
                    <div className="FrameBox4Reg FrameBox15Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Montant total')}</label>
                        <IconTextField
                            sx={{
                                '& > :not(style)': { width: '100%', borderRadius: '8px' },
                            }}
                            iconEnd={'€'}
                            //InputProps={{ endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>)}}
                            type="number"
                            name="Montant total"
                            //label='Montant Total'
                            // placeholder="Intitulé du poste"
                            // autoComplete="off"
                            // value={montantTotal}
                            value={montantTotal.toFixed(2)}
                            disabled
                        />
                    </div>
                </div>
            </div>
            }
            <div className="FrameBox0Reg">
                <h6 className='nomPrenomProfile'>
                    {i18n.t('Ajouter des détails')}
                </h6>
                <div className="FrameBox12Reg">
                    <TextFieldComponent
                        type="text"
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        style={{ width: '100%', background: 'white', borderRadius: '8px' }}
                        // name="intitulePoste"
                        placeholder={i18n.t('Ajouter des détails')}
                        autoComplete="off"
                        value={note}
                        onChange={(e) => {
                            setNote(e.target.value);
                        }}
                        disabled={defineRole(role) == 'client'|| role =='admin'|| (defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC)}
                    />
                    <Stack spacing={5}>
                        {(defineRole(role)=='expert'&& craX?.statutCraX != STATUS_CRA.VC) &&
                        <MultipleFilesUpload
                            PreviousFiles = {fileList}
                            setFiles={setFileList}
                        />}
                        {Array.isArray(fileList) && fileList.length>0 &&
                        <FileList
                            list={fileList}
                            setlist={setFileList}
                            mode={(role=='admin' ||defineRole(role)=='client'||(defineRole(role)=='expert' && craX?.statutCraX==STATUS_CRA.VC)) ? 'readOnly' :'' }
                        />}
                    </Stack>
                </div>
            </div>
            <div style={{display:'flex',flexDirection:'row',gap:'8px',justifyContent:'flex-end'}}>
                <Button
                    type="submit" //* yess i't good for accessibility, but cause some troubles
                    style={{...buttonStyles()}}
                    variant="outlined"
                    onClick={() => navigate('/'+role+'/AllCras')}
                >
                    {i18n.t('Retour')}
                </Button>
                {/* expert could not change anythig afetr validation client */}
                {/*{TODO : quand l'expert valide le crax le button doit pas etre afficher}*/}
                {(defineRole(role) == 'expert'
                && craX?.factureXId?.statutFactureX !== 'genere')
                // && craX?.statutCraX !== STATUS_CRA?.VC
                &&
                    <Button
                        type="submit" //* yess i't good for accessibility, but cause some troubles
                        style={{...buttonStylesGreen((getDisabledValidateRejectCraForACanceledMission(
                            cra?.missionId?.statutMission,
                            cra?.missionId?.BDCs,
                            cra?.bdcId?._id
                        )||disabledBtnValidation))}}
                        onClick={(e) => {
                            // debugger;
                            e.preventDefault();
                            addCraX();
                        }}
                        disabled={
                            getDisabledValidateRejectCraForACanceledMission(
                                cra?.missionId?.statutMission,
                                cra?.missionId?.BDCs,
                                cra?.bdcId?._id
                            )||disabledBtnValidation
                        }
                    >
                        {i18n.t('Valider')}
                    </Button>
                }
                {(defineRole(role) == 'client'
                && craX?.statutCraX !== STATUS_CRA?.pending
                && craX?.factureXId?.statutFactureX !== 'genere')
                // && craX?.statutCraX !== STATUS_CRA?.VC
                &&
                <div style={{display:'flex',flexDirection:'row',gap:'8px'}}>
                    <Button
                        variant='contained'
                        onClick={() => {
                            updateStatutCraXByClient({craXId: craXId, statutCraX: 'VC'});
                        }}
                        style={{...buttonStylesGreen(false)}}
                        disabled={
                            getDisabledValidateRejectCraForACanceledMission(
                                cra?.missionId?.statutMission,
                                cra?.missionId?.BDCs,
                                cra?.bdcId?._id
                            )
                        }
                    >
                        {i18n.t('Valider')}
                    </Button>
                    <Button
                        variant='contained'
                        onClick={() => { setOpenDialogRejetCras(true); }}
                        style={{...buttonStyles(),...{backgroundColor: '#F6AF39',color:'white',}}}
                        disabled={
                            getDisabledValidateRejectCraForACanceledMission(
                                cra?.missionId?.statutMission,
                                cra?.missionId?.BDCs,
                                cra?.bdcId?._id
                            )
                        }
                    >
                        {i18n.t('Rejeter')}
                    </Button>
                    <DialogRejetCraAndCraX
                        idCraX={craXId}
                        updateCraX={updateCraX}
                        setOpenDialogRejetCras={setOpenDialogRejetCras}
                        openDialogRejetCras={openDialogRejetCras}
                    />
                </div>}
            </div>
        </form>
    );
};

export default CraX;
